export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Robert Martinez',
      property: '16-Unit Apartment Complex',
      location: 'East El Paso',
      image: 'https://public.readdy.ai/ai/img_res/00910e1ed635ec974c9d93be6269dde4.jpg',
      rating: 5,
      text: 'I inherited a 16-unit apartment building and had no idea how to manage it from out of state. T-Rex Real Estate made me a fair offer, closed in 9 days through a title company, and handled everything. The process was incredibly smooth and professional. Highly recommend them to anyone looking to sell my apartments fast.'
    },
    {
      name: 'Patricia Johnson',
      property: '8-Unit Apartment Building',
      location: 'Central El Paso',
      image: 'https://readdy.ai/api/search-image?query=professional%20female%20business%20owner%20real%20estate%20investor%20satisfied%20customer%20portrait%20modern%20office%20background%20confident%20successful%20professional%20headshot&width=400&height=400&seq=sellapttesti2&orientation=squarish',
      rating: 5,
      text: 'After 20 years of being a landlord, I was ready to retire. I didn\'t want to deal with months of showings and repairs. T-Rex bought my apartments as-is, paid cash, and we closed in less than two weeks. They are true apartment buyers with the resources and professionalism to back it up.'
    },
    {
      name: 'David Chen',
      property: '24-Unit Garden Apartments',
      location: 'Northeast El Paso',
      image: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20business%20owner%20real%20estate%20investor%20satisfied%20customer%20portrait%20modern%20office%20background%20confident%20successful%20professional%20headshot&width=400&height=400&seq=sellapttesti3&orientation=squarish',
      rating: 5,
      text: 'I was skeptical about cash apartment buyers, but T-Rex proved they have a legitimate track record. They provided references, proof of funds, and closed through a reputable title company. The entire transaction was transparent and professional. If you need to sell my apartments, these are the buyers to call.'
    },
    {
      name: 'Maria Rodriguez',
      property: '6-Unit Duplex Complex',
      location: 'West El Paso',
      image: 'https://readdy.ai/api/search-image?query=professional%20hispanic%20female%20business%20owner%20real%20estate%20investor%20satisfied%20customer%20portrait%20modern%20office%20background%20confident%20successful%20professional%20headshot&width=400&height=400&seq=sellapttesti4&orientation=squarish',
      rating: 5,
      text: 'My property had several problem tenants and needed significant repairs. Traditional buyers wouldn\'t touch it. T-Rex made a fair offer considering the situation, bought it as-is, and handled all the tenant issues. They closed in 11 days and I walked away with cash. Couldn\'t be happier with the experience.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Testimonials
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What Apartment Sellers Say About Us
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what property owners who chose to sell my apartments to T-Rex Real Estate have to say about their experience.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300"
            >
              <div className="flex items-start space-x-4 mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-20 h-20 rounded-full object-cover object-top flex-shrink-0"
                />
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-gray-900 mb-1">{testimonial.name}</h3>
                  <div className="text-gray-600 mb-1">{testimonial.property}</div>
                  <div className="text-sm text-gray-500">{testimonial.location}</div>
                  <div className="flex space-x-1 mt-2">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed italic">"{testimonial.text}"</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-12 text-center text-white">
          <div className="max-w-3xl mx-auto">
            <div className="text-6xl font-bold mb-4">4.9/5</div>
            <div className="text-2xl font-bold mb-4">Average Seller Rating</div>
            <div className="flex justify-center space-x-1 mb-6">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-300 text-3xl"></i>
              ))}
            </div>
            <p className="text-xl text-teal-100 mb-8">
              Based on 150+ apartment building purchases across Texas. Our sellers consistently rate us highly for professionalism, fair offers, and smooth closings.
            </p>
            <div className="inline-flex items-center space-x-3 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-xl">
              <i className="ri-verified-badge-fill text-2xl"></i>
              <span className="font-semibold">All reviews verified through title company closings</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}